/* eslint-disable prettier/prettier */

// ** Third Party Components
import styled, { css } from "styled-components";

// #####################################################

// ** Design Tokens

const panelWrapperDesignTokens = css`
	// Text color
	--dz-comp-auth-panel-text-color: var(--dz-sys-text-color-always-light);

	// Border color
	--dz-comp-auth-panel-border-color: #646464;

	// Box shadow
	--dz-comp-auth-panel-box-shadow: var(--dz-sys-auth-panel-shadow);

	// Background color
	--dz-comp-auth-panel-background-color-selected: rgba(0, 0, 0, 0.5);
	--dz-comp-auth-panel-background-color-not-selected: rgba(0, 0, 0, 0.15);
	--dz-comp-auth-panel-background-color-not-selected-hover: rgba(0, 0, 0, 0.5);

	// Button outline
	--dz-comp-button-outline-text-color: var(--dz-sys-text-color-always-light);
	--dz-comp-button-outline-background-color: transparent;
	--dz-comp-button-outline-background-color-hover: var(--dz-ref-color-gray800);
	--dz-comp-button-outline-background-color-active: var(--dz-ref-color-gray900);
	--dz-comp-button-outline-border-color: var(--dz-ref-color-gray800);
`;

// #####################################################

export const StyledPanelWrapper = styled.div`
	${panelWrapperDesignTokens}

	display: block;
	border: 1px solid var(--dz-comp-auth-panel-border-color);
	border-radius: var(--dz-ref-border-radius-1-75);
`;

// #####################################################
